<template>
	<ClipList />
</template>

<script>
import ClipList from '../components/clip-list/ClipList';

export default {
	name:       'ClipListBlock',
	components: {
		ClipList,
	},
};
</script>

<style lang="scss" scoped>
</style>
